"use client";

import { createContext, useCallback, useContext, useState } from "react";
import ConfirmModal from "./ConfirmModal";
import PromptModal from "./PromptModal";

const DialogContext = createContext(null);

export function DialogProvider({ children }) {
  const [dialog, setDialog] = useState(null);

  const confirm = useCallback((opts) => {
    return new Promise((resolve) => {
      setDialog({ type: "confirm", opts: opts || {}, resolve });
    });
  }, []);

  const prompt = useCallback((opts) => {
    return new Promise((resolve) => {
      setDialog({ type: "prompt", opts: opts || {}, resolve });
    });
  }, []);

  const handleConfirm = useCallback((value) => {
    if (!dialog) return;
    dialog.resolve(value);
    setDialog(null);
  }, [dialog]);

  const handleCancel = useCallback(() => {
    if (!dialog) return;
    dialog.resolve(dialog.type === "confirm" ? false : null);
    setDialog(null);
  }, [dialog]);

  return (
    <DialogContext.Provider value={{ confirm, prompt }}>
      {children}
      {dialog?.type === "confirm" && (
        <ConfirmModal
          {...dialog.opts}
          onConfirm={() => handleConfirm(true)}
          onCancel={handleCancel}
        />
      )}
      {dialog?.type === "prompt" && (
        <PromptModal
          {...dialog.opts}
          onConfirm={(value) => handleConfirm(value)}
          onCancel={handleCancel}
        />
      )}
    </DialogContext.Provider>
  );
}

export function useDialogs() {
  const ctx = useContext(DialogContext);
  if (!ctx) {
    throw new Error("useDialogs must be used within DialogProvider");
  }
  return ctx;
}
